/* eslint-disable no-restricted-imports */
/**
 * Here we setup an axios instance for interacting with the backend.
 * It will setup the auth token automatically and take care of
 * refreshing it as needed.
 *
 * By setting up an instance here, we can still use axios for other
 * APIs without sending our auth token every time.
 */
import axios from "axios";
import { tokenSupplier } from "./webAuth";
import errors from "../errors";

const backend = axios.create({ withCredentials: true });
backend.interceptors.request.use(async function (config) {
  const token = await tokenSupplier.getToken();
  if (token) {
    config.headers.Authorization = token;
  } else {
    console.log("no user token available to send with this request");
  }
  return config;
});
backend.interceptors.request.use((config) => {
  config.headers.set("X-SNOW-WEB", "1");
  return config;
});
backend.defaults.withCredentials = true;
backend.defaults.baseURL =
  process.env.REACT_APP_BACKEND_API ?? "https://api.mysnowscape.com/v2/";
axios.defaults.withCredentials = true;
axios.defaults.baseURL =
  process.env.REACT_APP_BACKEND_API ?? "https://api.mysnowscape.com/v2/";

// Configure a global interceptor as well (would love to do away with this by having everything import from this file instead.)
// axios.interceptors.request.use(async function (config) {
//   const token = await tokenSupplier.getToken();
//   if (token) {
//     config.headers.Authorization = token;
//   } else {
//     console.log("no user token available to send with this request");
//   }
//   return config;
// });
// Add a response interceptor that will sign the user out on 401 responses
const _handle401Response = async (error) => {
  try {
    if (error && error.response && error.response.status === 401) {
      try {
        alert("Looks like your session has expired.  Please login again.");
        tokenSupplier.signOut();
        window.location.href = "/admin-login";
      } catch (e) {
        errors
          .report(e)
          .then((errorId) =>
            alert(
              `Unable to sign you out. Please clear your browser data and try logging in again. Error id: ${errorId}`,
            ),
          );
      }
    }
  } catch (e) {
    console.error("Error while handling 401 response:", e);
  }
  return Promise.reject(error);
};
/**
 * TODO: need to think about how the new auth manager might make requests using the default handler.  Do we want to update the 401 handler to not alert if we are on /embed? or /public?
 * TODO: update CI to run lint and not pass the project if there are lint errors.
 */
backend.interceptors.response.use((resp) => resp, _handle401Response);
// axios.interceptors.response.use((resp) => resp, _handle401Response);
/**
 * @type {import('axios').AxiosInstance}
 */
export default backend;

export function isAxiosError(err) {
  return axios.isAxiosError(err);
}
